module.exports = __webpack_public_path__ + "img/yinlian.bdc62ff0.png";